export default __webpack_public_path__ + "static/C03-0ff2e157e80784704599790952fdcbbf.jpg";